import { memo } from "react"
import { Box, Container, Heading, Flex, Text } from "@chakra-ui/react"
import { useContent } from "@app/hooks/useContent"
import { TwoColumnsColumn } from "./TwoColumnsColumn"

const TwoColumns: React.FC<GatsbyTypes.SanitySectionTwoColumns> = ({
  bgColor,
  title,
  aboveColumnsText: rawAboveColumnsText,
  belowColumnsText,
  columns,
}) => {
  const { getContent } = useContent()
  const aboveColumnsText = getContent({ content: rawAboveColumnsText })
  const hasColumns = !!columns?.length

  return (
    <Box bgColor={bgColor} pt={[12, 12, 18]} pb={[14, 14, 12]}>
      <Container textAlign={["left", "center", "center"]} px={[5, 5, 5, 40]}>
        <Flex alignItems={["flex-start", "center"]} direction="column" maxW="666px" mx="auto">
          {title && (
            <Heading as="p" fontSize={["5xl", "5xl", "6xl"]} maxW="550px" mb={[4, 4, 6]} textAlign="inherit">
              {title}
            </Heading>
          )}
          <Box textAlign="inherit" sx={{ "& p": { fontSize: ["sm"], lineHeight: "21px" } }} mb={[8, 8, 16]}>
            {aboveColumnsText}
          </Box>
        </Flex>
        {hasColumns && (
          <Flex direction={["column", "column", "row"]} columnGap={[0, 4]} rowGap={[12, 12, 0]} justifyContent="center">
            {columns?.map(column => (
              <TwoColumnsColumn key={column?._key} column={column} />
            ))}
          </Flex>
        )}
        {belowColumnsText && (
          <Text
            fontSize={["xs", "xs", "sm"]}
            mt={[8, 8, 20]}
            textAlign="inherit"
            borderTop={["0.5px", "none"]}
            pt={[8, 0]}
            borderTopColor="rgba(20,59,52, 0.5)"
          >
            {belowColumnsText}
          </Text>
        )}
      </Container>
    </Box>
  )
}

export default memo(TwoColumns)
